jQuery(document).ready(function(){
    setTimeout(function(){
        resetModalFilters(true);
    }, 1000);
});

function buildFilterBlock(init){
    // Costruisci i filtri della modale recuperandoli da bc-sf (App)
    var bcSfFilterBlocks = jQuery('#bc-sf-filter-tree-h .bc-sf-filter-option-block');

    // Container dei filtri della modale
    var customFiltersBlock = jQuery('#caffitaly-filters .filter-blocks');
    customFiltersBlock.html(""); // RESET

    // Iterazione sulle categorie di filtro
    bcSfFilterBlocks.each(function(){

        var bcSfFilterBlock = jQuery(this);

        var title = bcSfFilterBlock.find('.bc-sf-filter-block-title span').text();
        // Recupero il template per la categoria di filtro della modale
        var customFilterBlock = customFilterTemplate.filterBlockHtml;
        // Inserisco il title della categoria
        customFilterBlock = customFilterBlock.replace(/{{filter_title}}/g, title);
        customFilterBlock = jQuery(customFilterBlock);

        var filterOptions = customFilterBlock.find('.filter-options');

        // Itero sulle options della categoria corrente di bc-sf (App)
        bcSfFilterBlock.find('.bc-sf-filter-block-content ul li a').each(function(){

            // Per ogni opzione bc-sf costruisco l'analoga della modale
            var bcSfOption = jQuery(this);

            // Recupero il template dell'opzione del filtro della modale
            var newOption = customFilterTemplate.filterOptionHtml;
            if(bcSfOption.data('id') == 'pf_t_intensita'){
                newOption = customFilterTemplate.intensitaFilterOptionHtml;
            }
            // Replace dei placeholders
            newOption = newOption.replace(/{{filter_id}}/g, bcSfOption.data('id'));
            newOption = newOption.replace(/{{filter_value}}/g, bcSfOption.data('value'));
            newOption = newOption.replace(/{{filter_label}}/g, bcSfOption.find('.bc-sf-filter-option-value').text());

            newOption = jQuery(newOption);
            // Sul click della label (finta checkbox), faccio la change della vera checkbox
            newOption.find('label').click(function(){
                // per qualche motivo, senza il setTimeout la checkbox viene subito resettata
                // c'è qualche script che va in conflitto, ma non abbiamo trovato quale
                setTimeout(function(){
                    var checkbox = jQuery(this).parent().find('input');
                    checkbox.prop('checked', !checkbox.prop('checked'));
                }, 100);
            });

            // Inizializzo la spunta della checkbox del filtro modale con il valore della checkbox bc-sf
            // (Serve per il redraw e per il rientro in pagina prefiltrata)
            newOption.find('input').prop('checked', bcSfOption.hasClass('selected'));

            // Aggiungo la option del filtro della modale
            filterOptions.append(newOption);

        });

        // Aggiungo la categoria di filtro della modale
        customFiltersBlock.append(customFilterBlock);

    });
 	$("#bc-sf-filter-products").show();
}

function applyModalFilters(){
    // Recupera ogni filtro della modale
    jQuery('#caffitaly-filters .filter-option input').each(function(){
        var caffitalyCheckbox = jQuery(this);
        // Recupera il filtro bc-sf (App)
        var bcSfFilter = jQuery('[data-value="' + caffitalyCheckbox.attr('id') + '"]');
        // Se le checkbox di modale e bc-sf sono disallineate
        if(caffitalyCheckbox.is(':checked') !== bcSfFilter.hasClass('selected')){
            // propaga la change del filtro modale al filtro bc-sf per allinearlo
            bcSfFilter.click();
        }
    });
    // Ridisegna i filtri disponibili, prendendoli da bc-sf
  	$(".filters-toggle").click();
}

function resetModalFilters(event){
    // Spegni tutte le checkbox della modale
    jQuery('#caffitaly-filters .filter-option input').prop('checked', false);
    // Invoca una funzione di reset di bc-sf
    clearAllFilterOptions(event);
    // Ridisegna i filtri disponibili, prendendoli da bc-sf
    setTimeout(buildFilterBlock, 100); // REDRAW
    $('#filtersModal').modal('hide');
};
